/**
 * L'URL decoupled d'une unité — une seule source de vérité.
 *
 * Deux appelants la construisent : le montage par référence (`UnitMount`) et la
 * copie d'un bloc partagé (« Rendre indépendant »). Réécrite à la main, elle
 * dérivait déjà — l'un encodait le nid, l'autre non.
 */
export const unitEndpoint = (nid) =>
  `/decoupled-api/node/builder_unit/${encodeURIComponent(nid)}?display=decoupled`
